// components/Admin/FarmerStats.js
import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAlert } from "../Alert";
import instance from "../../globals/axios";
import AdminDashboardCard from "../Custom/AdminDashboardCard";
import { isNotNullOrEmptyArray } from "../../globals/utils";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SERVER_BASE_ADDRESS } from "../../globals/const";

const FarmerStats = () => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const { access_key } = useParams();
  const isReport = !!access_key;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response;

        if (isReport) {
          const url = `${SERVER_BASE_ADDRESS}/app-admin/get-overview-stats/`;
          response = await axios.get(url, {
            headers: {
              Authorization: `Token ${access_key}`,
            },
          });
        } else {
          response = await instance.get("/app-admin/get-overview-stats/");
        }

        if (response?.data?.data) {
          const {
            onboarded_farmers,
            mapped_acres,
            soil_tests,
            satellite_data,
          } = response.data.data || {};
          const metrics = [
            {
              label: "Onboarded Farmers",
              value: onboarded_farmers,
              color: "#FFBB28",
            },
            {
              label: "Mapped Area (Acres)",
              value: mapped_acres,
              color: "#FF8042",
            },
            { label: "Soil Tests", value: soil_tests, color: "#0088FE" },
            {
              label: "Satellite Data (Acres)",
              value: satellite_data,
              color: "#00C49F",
            },
          ];
          setData(metrics);
        } else {
          showAlert("error", "Failed to fetch data");
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
        showAlert("error", "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Box
      sx={{
        padding: {
          lg: "30px",
        },
      }}
    >
      <>
        {!isReport && loading ? (
          <Typography variant="h6">{`${t("Loading")}...`}</Typography>
        ) : isNotNullOrEmptyArray(data) ? (
          data.map((item, index) => {
            return (
              <AdminDashboardCard
                key={index}
                label={item.label}
                value={item.value}
                color={item.color}
              />
            );
          })
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <Typography variant="h6">{t("No data available")}</Typography>
          </Box>
        )}
      </>
    </Box>
  );
};

export default FarmerStats;
